export default "__VITE_ASSET__lfwmC8St__"